import React, { useEffect, useState, createRef } from 'react';
import '../../App.css';
import './ReportsPage.css';
import axios from 'axios';
import withNavigation from './../withNavigation';
import { API_URL } from './../environment';
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import * as XLSX from 'xlsx';


class ReportsPage extends React.Component {
  
  

  state = {
    wager: 0,
    totalPayout: 0,
    gross: 0,
    redeemedPayout: 0,
    eligibleJackpotPayout: 0,
    redeemedJackpotPayout: 0,
    selWager: 0,
    selTotalPayout: 0,
    selGross: 0,
    selRedeemedPayout: 0,
    selRedeemedJackpotPayout: 0,
    selEligibleJackpotPayout: 0,
    shopData: [],
    selectedShopData: [],
    selectedShopId: null,
    startDate: '',
    endDate: '',
    selectingEnd: '',
    isCalendarVisible: false,
    selectedDate: null,
    activeDateSelected: '',
    shopToDaysDataMap: {},
    isExpandMode: false,
    reportViewMode: 'shops',
    dailyReportData: [],
  }
  

  constructor(props) {
    super(props);
    this.calendarRef = createRef();
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  parseDateString = (dateStr) => {
    const regex = /^(\d{2})_(\d{2})_(\d{4})$/;
    const match = dateStr.match(regex);
    if (!match) return null;
    const [, day, month, year] = match;
    const monthNum = parseInt(month, 10);
    const dayNum = parseInt(day, 10);
    const yearNum = parseInt(year, 10);
    if (
      monthNum < 1 || monthNum > 12 ||
      dayNum < 1 || dayNum > 31 ||
      yearNum < 1000 || yearNum > 9999
    ) {
      return null;
    }
    return new Date(yearNum, monthNum, dayNum);
  };

  parseReportResponseForConsole = (data) => {
    try {
      return typeof data === 'string'
        ? JSON.parse(data)
        : JSON.parse(JSON.stringify(data));
    } catch (error) {
      console.warn('Unable to JSON.parse reportsbyshopdaily response', error);
      return data;
    }
  };

  extractReportResult = (data) => {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.result)) return data.result;
    if (data && Array.isArray(data.response)) return data.response;
    return [];
  };

  toNumber = (value) => Number(value) || 0;

  getReportRowDate = (item = {}, index = 0) => (
    item.date || item.dayData || item._id || item.shopName || `day-${index}`
  );

  getDetailedReportFields = () => [
    'numTicketsSold',
    'totalWager',
    'numTicketsLiveRedeemed',
    'payoutLiveRedeemed',
    'numTicketsDelayedRedeemed',
    'payoutDelayedRedeemed',
    'numTicketsEligible',
    'payoutEligible',
    'numJackpotLiveRedeemed',
    'jackpotLiveRedeemed',
    'numJackpotDelayedRedeemed',
    'jackpotDelayedRedeemed',
    'numJackpotEligible',
    'jackpotEligible',
    'numTicketsExpired',
    'totalExpired',
    'gross',
  ];

  getDetailedReportCurrencyFields = () => new Set([
    'totalWager',
    'payoutLiveRedeemed',
    'payoutDelayedRedeemed',
    'payoutEligible',
    'jackpotLiveRedeemed',
    'jackpotDelayedRedeemed',
    'jackpotEligible',
    'totalExpired',
    'gross',
  ]);

  normalizeReportRow = (item = {}, index = 0) => {
    const hasValue = (fieldName) => item[fieldName] !== undefined && item[fieldName] !== null;
    const rowDate = this.getReportRowDate(item, index);
    const numTicketsSold = hasValue('numTicketsSold')
      ? this.toNumber(item.numTicketsSold)
      : this.toNumber(item.numberSoldTickets);
    const totalWager = hasValue('totalWager')
      ? this.toNumber(item.totalWager)
      : this.toNumber(item.totalBetAmount);
    const numTicketsLiveRedeemed = hasValue('numTicketsLiveRedeemed')
      ? this.toNumber(item.numTicketsLiveRedeemed)
      : this.toNumber(item.numberRedeemedTickets);
    const payoutLiveRedeemed = hasValue('payoutLiveRedeemed')
      ? this.toNumber(item.payoutLiveRedeemed)
      : this.toNumber(item.totalRedeemedPayout);
    const numTicketsDelayedRedeemed = this.toNumber(item.numTicketsDelayedRedeemed);
    const payoutDelayedRedeemed = this.toNumber(item.payoutDelayedRedeemed);
    const numTicketsEligible = this.toNumber(item.numTicketsEligible);
    const payoutEligible = hasValue('payoutEligible')
      ? this.toNumber(item.payoutEligible)
      : this.toNumber(item.totalPayoutAmount);
    const numJackpotLiveRedeemed = this.toNumber(item.numJackpotLiveRedeemed);
    const jackpotLiveRedeemed = hasValue('jackpotLiveRedeemed')
      ? this.toNumber(item.jackpotLiveRedeemed)
      : this.toNumber(item.totalRedeemedJackpotPayout);
    const numJackpotDelayedRedeemed = this.toNumber(item.numJackpotDelayedRedeemed);
    const jackpotDelayedRedeemed = this.toNumber(item.jackpotDelayedRedeemed);
    const numJackpotEligible = this.toNumber(item.numJackpotEligible);
    const jackpotEligible = hasValue('jackpotEligible')
      ? this.toNumber(item.jackpotEligible)
      : this.toNumber(item.totalEligibleJackpotPayout);
    const numTicketsExpired = this.toNumber(item.numTicketsExpired);
    const totalExpired = this.toNumber(item.totalExpired);
    const gross = hasValue('gross')
      ? this.toNumber(item.gross)
      : this.toNumber(item.netAmount);

    return {
      ...item,
      date: rowDate,
      shopName: rowDate,
      dayData: rowDate,
      numTicketsSold,
      totalWager,
      numTicketsLiveRedeemed,
      payoutLiveRedeemed,
      numTicketsDelayedRedeemed,
      payoutDelayedRedeemed,
      numTicketsEligible,
      payoutEligible,
      numJackpotLiveRedeemed,
      jackpotLiveRedeemed,
      numJackpotDelayedRedeemed,
      jackpotDelayedRedeemed,
      numJackpotEligible,
      jackpotEligible,
      numTicketsExpired,
      totalExpired,
      gross,
      totalBetAmount: totalWager,
      totalRedeemedPayout: payoutLiveRedeemed + payoutDelayedRedeemed,
      totalPayoutAmount: payoutEligible,
      totalRedeemedJackpotPayout: jackpotLiveRedeemed + jackpotDelayedRedeemed,
      totalEligibleJackpotPayout: jackpotEligible,
      netAmount: gross,
      numberSoldTickets: numTicketsSold,
      numberRedeemedTickets: numTicketsLiveRedeemed + numTicketsDelayedRedeemed,
    };
  };

  createReportAggregate = (base = {}) => {
    const aggregate = {
      ...base,
      totalBetAmount: 0,
      totalPayoutAmount: 0,
      netAmount: 0,
      totalRedeemedPayout: 0,
      totalRedeemedJackpotPayout: 0,
      totalEligibleJackpotPayout: 0,
      numberSoldTickets: 0,
      numberRedeemedTickets: 0,
    };

    this.getDetailedReportFields().forEach((field) => {
      aggregate[field] = 0;
    });

    return aggregate;
  };

  addReportTotals = (acc, item) => {
    this.getDetailedReportFields().forEach((field) => {
      acc[field] = (acc[field] || 0) + this.toNumber(item[field]);
    });

    acc.totalBetAmount += item.totalBetAmount || 0;
    acc.totalPayoutAmount += item.totalPayoutAmount || 0;
    acc.netAmount += item.netAmount || 0;
    acc.totalRedeemedPayout += item.totalRedeemedPayout || 0;
    acc.totalRedeemedJackpotPayout += item.totalRedeemedJackpotPayout || 0;
    acc.totalEligibleJackpotPayout += item.totalEligibleJackpotPayout || 0;
    acc.numberSoldTickets += item.numberSoldTickets || 0;
    acc.numberRedeemedTickets += item.numberRedeemedTickets || 0;
    return acc;
  };

  getReportDateTime = (dateValue) => {
    if (!dateValue) return 0;

    const dateString = String(dateValue);
    if (/^\d{2}_\d{2}_\d{4}$/.test(dateString)) {
      const parsedDate = this.parseDateString(dateString);
      return parsedDate ? parsedDate.getTime() : 0;
    }

    const timestamp = Date.parse(dateString);
    return Number.isFinite(timestamp) ? timestamp : 0;
  };

  buildDailyReportState = (dailyResult = []) => {
    const dailyReportData = dailyResult.map((item, index) => this.normalizeReportRow(item, index));

    const totals = dailyReportData.reduce(
      (acc, item) => {
        acc.wager += item.totalBetAmount || 0;
        acc.redeemedPayout += item.totalRedeemedPayout || 0;
        acc.totalPayout += item.totalPayoutAmount || 0;
        acc.redeemedJackpotPayout += item.totalRedeemedJackpotPayout || 0;
        acc.eligibleJackpotPayout += item.totalEligibleJackpotPayout || 0;
        acc.gross += item.netAmount || 0;
        return acc;
      },
      {
        wager: 0,
        redeemedPayout: 0,
        totalPayout: 0,
        redeemedJackpotPayout: 0,
        eligibleJackpotPayout: 0,
        gross: 0,
      }
    );

    return {
      ...totals,
      dailyReportData,
      isExpandMode: false,
      selectedShopData: [],
      selectedShopId: null,
    };
  };

  async refreshReports(custStartDate, custEndDate, isCustom = false) {
    let reportsParams = {custom: isCustom};

    

    // Check if startDate and endDate exist in the state and add them to the params
    if (this.state.startDate) {
      reportsParams.startDate = this.state.startDate;
    }
    if (this.state.endDate) {
      reportsParams.endDate = this.state.endDate;
    }

    if (custStartDate) {
      reportsParams.startDate = custStartDate;
    }

    if (custEndDate) {
      reportsParams.endDate = custEndDate;
    }

    const buildDailyRangeValue = (value, startOfDay = true) => {
      if (!value) return "";

      if (moment.isMoment(value)) {
        return startOfDay
          ? moment(value).startOf("day").toISOString()
          : moment(value).endOf("day").toISOString();
      }

      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return startOfDay
          ? moment(value).startOf("day").toISOString()
          : moment(value).endOf("day").toISOString();
      }

      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? value : date.toISOString();
    };

    const dailyStartTime = buildDailyRangeValue(reportsParams.startDate, true);
    const dailyEndTime = buildDailyRangeValue(reportsParams.endDate, false);



    // Choose the timezone you want the backend to treat as "the day".
    // - Use browser TZ (default) to match how the user picked TODAY/YESTERDAY.
    // - Or hardcode your business TZ like 'Europe/Uzhgorod' if needed.
    const DEFAULT_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // const REPORTS_TZ = "Europe/Uzhgorod";
    const REPORTS_TZ = DEFAULT_TZ;

    const convertToDateOnly = (value, timeZone = REPORTS_TZ) => {
      if (!value) return "";

      // If it's already YYYY-MM-DD, keep it as-is
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return "";

      // Build YYYY-MM-DD in the requested timezone (not UTC)
      const parts = new Intl.DateTimeFormat("en-CA", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).formatToParts(d);

      const y = parts.find((p) => p.type === "year")?.value;
      const m = parts.find((p) => p.type === "month")?.value;
      const da = parts.find((p) => p.type === "day")?.value;

      return `${y}-${m}-${da}`;
    };

    const ONE_DAY_MS = 24 * 60 * 60 * 1000;
// console.log('reportsParams', reportsParams);
    if (reportsParams.startDate && reportsParams.endDate) {
      const startMs = Date.parse(reportsParams.startDate);
      const endMs = Date.parse(reportsParams.endDate);

      const startDay = convertToDateOnly(reportsParams.startDate);
      const endDay = convertToDateOnly(reportsParams.endDate);

      // Best: use an explicit flag if you have it:
      // const singleDayPreset =
      //   reportsParams.activeDateSelected === "TODAY" ||
      //   reportsParams.activeDateSelected === "YESTERDAY";

      // Fallback: detect the "single-day preset" by duration (< 24h)
      const singleDayPreset =
        Number.isFinite(startMs) &&
        Number.isFinite(endMs) &&
        endMs - startMs < ONE_DAY_MS;

      reportsParams.startDate = startDay;
      reportsParams.endDate = singleDayPreset ? startDay : endDay;
    } else {
      if (reportsParams.startDate) {
        reportsParams.startDate = convertToDateOnly(reportsParams.startDate);
      }
      if (reportsParams.endDate) {
        reportsParams.endDate = convertToDateOnly(reportsParams.endDate);
      }
    }



    if (this.state.reportViewMode === 'days') {
      const dailyReportsParams = { custom: isCustom };

      if (dailyStartTime) {
        dailyReportsParams.startDate = dailyStartTime;
      }
      if (dailyEndTime) {
        dailyReportsParams.endDate = dailyEndTime;
      }

      const shopIds = localStorage.getItem('sun_bettingShopsList').split(',')
      if (shopIds.length) {
        dailyReportsParams.bettingShopIdList = JSON.stringify(shopIds); // { $in : shopIds });
      }

      const responseByShopDaily = await axios.get(`${API_URL}/reportsbyshopdaily`, {
        params: dailyReportsParams,
      });
      const parsedDailyResponse = this.parseReportResponseForConsole(responseByShopDaily && responseByShopDaily.data);
      const dailyResult = this.extractReportResult(parsedDailyResponse);

      // console.log('reportsbyshopdaily response', responseByShopDaily && responseByShopDaily.data);
      // console.log('reportsbyshopdaily JSON.parse response', parsedDailyResponse);
      this.setState(this.buildDailyReportState(dailyResult));
      return;
    }

    const storedUser = JSON.parse(localStorage.getItem("sun_user"));
    const isAdmin = storedUser && storedUser.role === 'ADMIN';
    // const betShopRest = localStorage.getItem('sun_bettingShopId');
    // if (!isAdmin && betShopRest && betShopRest !== 'undefined' && betShopRest !== '-') {
    //   reportsParams.bettingShopId = betShopRest;
    // }

    const shopIds = localStorage.getItem('sun_bettingShopsList').split(',')
    if (shopIds.length) {
      reportsParams.bettingShopIdList = JSON.stringify(shopIds); // { $in : shopIds });
    }


    // load reports by shop
    const responseByShop = await axios.get(`${API_URL}/reportsbyshop`, {
      params: reportsParams,
    });
    const shopData = this.extractReportResult(responseByShop && responseByShop.data)
      .map((item, index) => this.normalizeReportRow(item, index));

    const shopToDaysDataMap = shopData.reduce((map, item) => {
      const { bettingShopId } = item;
      if (!bettingShopId) return map;

      const dayKey = this.getReportRowDate(item);
      if (!map[bettingShopId]) {
        map[bettingShopId] = {};
      }
      if (!map[bettingShopId][dayKey]) {
        map[bettingShopId][dayKey] = this.createReportAggregate({
          ...item,
          bettingShopId,
          shopName: dayKey,
          dayData: dayKey,
        });
      }

      this.addReportTotals(map[bettingShopId][dayKey], item);
      return map;
    }, {});

    const aggregatedData = shopData.reduce((acc, item) => {
      const { bettingShopId } = item;
      if (!bettingShopId) return acc;

      if (!acc[bettingShopId]) {
        acc[bettingShopId] = this.createReportAggregate({ bettingShopId });
      }

      this.addReportTotals(acc[bettingShopId], item);
      return acc;
    }, {});

    // Convert the result object into an array
    let resultDataShop = Object.values(aggregatedData);
    const existingShopIds = resultDataShop.map(o => o.bettingShopId);

    const responseShopsList = await axios.get(`${API_URL}/bettingshops`); // Example API URL

    const allowedShopIds = localStorage.getItem('sun_bettingShopsList').split(',') || []

    let shopsListRaw = (responseShopsList.data || []).reverse();

    let shopsList = shopsListRaw.concat();
    if (allowedShopIds.length) {
      shopsList = shopsList.filter(o => allowedShopIds.includes(o._id));
    }

    for (const shop of shopsList) {
      if ( !existingShopIds.includes(shop._id) ) {
        resultDataShop.push(this.createReportAggregate({ bettingShopId: shop._id }))
      }
    }


    let shopNamesMap = {};
    for (const shop of shopsList) {
      shopNamesMap[shop._id] = shop.name;
    }

    resultDataShop = resultDataShop.map(o => {
      o.shopName = shopNamesMap[o.bettingShopId];
      return o;
    });

    resultDataShop = resultDataShop.filter(o => o.shopName);

    // calculate total data
    const aggData = resultDataShop.reduce(
      (acc, item) => {
        acc.gross += item.netAmount || 0;
        acc.totalPayout += item.totalPayoutAmount || 0;
        acc.wager += item.totalBetAmount || 0;
        acc.redeemedPayout += item.totalRedeemedPayout || 0;
        acc.redeemedJackpotPayout += item.totalRedeemedJackpotPayout || 0;
        acc.eligibleJackpotPayout += item.totalEligibleJackpotPayout || 0;
        return acc;
      },
      { gross: 0, totalPayout: 0, wager: 0, redeemedPayout: 0, jackpotPayout: 0, eligibleJackpotPayout: 0, redeemedJackpotPayout: 0, } // Initial values
    );

    const sortedShopDaysMap = {};
    Object.keys(shopToDaysDataMap).forEach((shopId) => {
      const sortedArray = Object.values(shopToDaysDataMap[shopId]).sort(
        (a, b) => this.getReportDateTime(a.dayData) - this.getReportDateTime(b.dayData)
      );
      sortedShopDaysMap[shopId] = sortedArray;
    });

    // check if it's expand mode and we have selected shopId
    let newState = {
      wager: aggData.wager,
      totalPayout: aggData.totalPayout,
      gross: aggData.gross,
      redeemedPayout: aggData.redeemedPayout,
      redeemedJackpotPayout: aggData.redeemedJackpotPayout,
      eligibleJackpotPayout: aggData.eligibleJackpotPayout,
      shopData: resultDataShop,
      shopToDaysDataMap: sortedShopDaysMap,
    };

    if (this.state.isExpandMode) {
      const selectedShopSummary = resultDataShop.find((item) => item.bettingShopId === this.state.selectedShopId);
      newState.selectedShopData = sortedShopDaysMap[this.state.selectedShopId] || [];
      if (selectedShopSummary) {
        newState.selWager = selectedShopSummary.totalBetAmount || 0;
        newState.selTotalPayout = selectedShopSummary.totalPayoutAmount || 0;
        newState.selGross = selectedShopSummary.netAmount || 0;
        newState.selRedeemedPayout = selectedShopSummary.totalRedeemedPayout || 0;
        newState.selRedeemedJackpotPayout = selectedShopSummary.totalRedeemedJackpotPayout || 0;
        newState.selEligibleJackpotPayout = selectedShopSummary.totalEligibleJackpotPayout || 0;
      }
    }

    this.setState(newState);
  }

  async componentDidMount() {
    document.body.classList.add('validate-active');
    await this.handleDateRange("TODAY");
    // await this.refreshReports();
  }

 
  componentWillUnmount() { 
    clearTimeout(this.timer);
  }

  async handleDateChange(date) {
    // If user is typing or navigating months (returns string in react-datetime):
    if (typeof date === "string") return;
  
    // Helper function to format dates
    const formatDate = (d, startOfDay = true) => {
      return startOfDay
        ? moment(d).startOf("day").format("YYYY-MM-DD")
        : moment(d).endOf("day").format("YYYY-MM-DD");
    };
  
    // If no start date is chosen, or if both are set (meaning we want to start a new range):
    if (!this.state.startDate || (this.state.startDate && this.state.endDate)) {
      this.setState({
        startDate: date,    // keep as Moment
        endDate: null,
        selectingEnd: true
      });
    } else {
      // We have a start date but no end date: user is picking the end date
      let start = this.state.startDate; // a Moment
      let end   = date;                 // a Moment
  
      if (end.isBefore(start, "day")) {
        // Swap if end date is before start date
        [start, end] = [end, start];
      }
  
      // If start date and end date are the same, extend end date by 1 day
      // if (start.isSame(end, "day")) {
      //   end = moment(end).add(1, "day");
      // }
  
      // Update state
      this.setState({
        startDate: start,  // still a Moment
        endDate: end,      // still a Moment
        selectingEnd: false
      });
  
      // Now fetch data with properly formatted dates
      await this.refreshReports(formatDate(start), formatDate(end, false), true);
    }
  }
  

  handleClickShop = async (shopId, shopData = {}) => {
    this.setState({
      isExpandMode: true,
      selectedShopData: this.state.shopToDaysDataMap[shopId] || [],
      selectedShopId: shopId,
      selWager: shopData.totalBetAmount || 0,
      selTotalPayout: shopData.totalPayoutAmount || 0,
      selGross: shopData.netAmount || 0,
      selRedeemedPayout: shopData.totalRedeemedPayout || 0,
      selRedeemedJackpotPayout: shopData.totalRedeemedJackpotPayout || 0,
      selEligibleJackpotPayout: shopData.totalEligibleJackpotPayout || 0,
    });
  };

  handleClickNormalMode = () => {
    this.setState({
      isExpandMode: false,
      selectedShopData: [],
      selectedShopId: null,
    });
  }

  handleReportViewModeChange = (event) => {
    const reportViewMode = event.target.value;

    this.setState({
      reportViewMode,
      isExpandMode: false,
      selectedShopData: [],
      selectedShopId: null,
    }, async () => {
      if (this.state.startDate && this.state.endDate) {
        await this.refreshReports(
          this.state.startDate,
          this.state.endDate,
          this.state.activeDateSelected === 'CUSTOM'
        );
      }
    });
  };


  handleDateRange = async (range, isCustom = false) => {
    let startDate = "", endDate = ""; // Initialize as empty strings
    let activeDateSelected = "";
  
    if (range === "CUSTOM") {
      this.setState({
        startDate: "",
        endDate: "",
        selectingEnd: false,
        isCalendarVisible: true,
        activeDateSelected: "CUSTOM",
      });
      return;
    }
  
    const today = new Date(); // Get the current date and time
  
    // switch (range) {
    //   case "TODAY":
    //     startDate = new Date();
    //     startDate.setHours(0, 0, 0, 0); // Set to the start of the day
    //     endDate = new Date();
    //     endDate.setHours(23, 59, 59, 999); // Set to the end of the day
    //     activeDateSelected = "TODAY";
    //     break;
  
    //   case "YESTERDAY":
    //     startDate = new Date();
    //     startDate.setDate(today.getDate() - 1);
    //     startDate.setHours(0, 0, 0, 0);
  
    //     endDate = new Date();
    //     endDate.setDate(today.getDate() - 1);
    //     endDate.setHours(23, 59, 59, 999);
    //     activeDateSelected = "YESTERDAY";
    //     break;
        
    //   case "LAST_7_DAYS":
    //     startDate = new Date();
    //     startDate.setDate(today.getDate() - 6);
    //     startDate.setHours(0, 0, 0, 0);
  
    //     endDate = new Date();
    //     endDate.setHours(23, 59, 59, 999);
    //     activeDateSelected = "LAST_7_DAYS";
    //     break;
  
    //   case "LAST_30_DAYS":
    //     startDate = new Date();
    //     startDate.setDate(today.getDate() - 29);
    //     startDate.setHours(0, 0, 0, 0);
  
    //     endDate = new Date();
    //     endDate.setHours(23, 59, 59, 999);
    //     activeDateSelected = "LAST_30_DAYS";
    //     break;
  
    //   default:
    //     startDate = "";
    //     endDate = "";
    // }
  
    // // Convert to ISO format (YYYY-MM-DD)
    // startDate = startDate ? startDate.toISOString().split("T")[0] : "";
    // endDate = endDate ? endDate.toISOString().split("T")[0] : "";
  
    



    switch (range) {
      case "TODAY":
        startDate = new Date(today.setHours(0, 0, 0, 0)).toISOString();
        endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
        activeDateSelected = "TODAY";
        break;

      case "YESTERDAY":
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        startDate = new Date(yesterday.setHours(0, 0, 0, 0)).toISOString();
        endDate = new Date(yesterday.setHours(23, 59, 59, 999)).toISOString();
        activeDateSelected = "YESTERDAY";
        break;

      case "LAST_7_DAYS":
        const last7Days = new Date(today);
        last7Days.setDate(today.getDate() - 6);
        startDate = new Date(last7Days.setHours(0, 0, 0, 0)).toISOString();
        endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
        activeDateSelected = "LAST_7_DAYS";
        break;

      case "LAST_30_DAYS":
        const last30Days = new Date(today);
        last30Days.setDate(today.getDate() - 29);
        startDate = new Date(last30Days.setHours(0, 0, 0, 0)).toISOString();
        endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
        activeDateSelected = "LAST_30_DAYS";
        break;

      default:
        startDate = "";
        endDate = "";
        break;
    }

    const formatDate = (d, startOfDay = true) => {
      return startOfDay
        ? moment(d).startOf("day").toISOString()
        : moment(d).endOf("day").toISOString();
    };
  
    // Format the dates for API call
    startDate = formatDate(startDate, true);
    endDate = formatDate(endDate, false);




  
    this.setState({
      startDate,
      endDate,
      activeDateSelected,
      isCalendarVisible: false, // Hide calendar for non-custom selections

      isExpandMode: false,
      selectedShopData: [],
      selectedShopId: null,
    });
  
    if (startDate && endDate) {
      await this.refreshReports(startDate, endDate, isCustom);
    }
  
    console.log("Date Range Selected:", { startDate, endDate });
  };
  

  formatCurrency = (value) => {
    if (typeof value !== "number") {
      return '-'; // throw new Error("Input must be a number");
    }
  
    return value.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  formatExportColumnName = (fieldName) => (
    String(fieldName)
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, (char) => char.toUpperCase())
  );

  getExportNumericValue = (value) => this.toNumber(value);

  getExportFileName = () => {
    const { startDate, endDate } = this.state;
    const formattedStart = moment(startDate).format("DDMMMYYYY");
    const formattedEnd = moment(endDate).format("DDMMMYYYY");

    return formattedStart === formattedEnd
      ? formattedStart
      : `${formattedStart}_${formattedEnd}`;
  };

  buildDetailedReportExportRows = ({
    data = [],
    firstColumnHeader,
    firstColumnValue,
    totalLabel = 'TOTAL',
  }) => {
    const detailedFields = this.getDetailedReportFields();
    const headers = [
      firstColumnHeader,
      ...detailedFields.map((field) => this.formatExportColumnName(field)),
    ];
    const totals = this.createReportAggregate({});
    const rows = data.map((item) => {
      const row = {
        [firstColumnHeader]: firstColumnValue(item),
      };

      detailedFields.forEach((field) => {
        const columnName = this.formatExportColumnName(field);
        row[columnName] = this.getExportNumericValue(item[field]);
      });
      this.addReportTotals(totals, item);
      return row;
    });

    const totalRow = {
      [firstColumnHeader]: totalLabel,
    };
    detailedFields.forEach((field) => {
      const columnName = this.formatExportColumnName(field);
      totalRow[columnName] = this.getExportNumericValue(totals[field]);
    });

    return {
      headers,
      rows: [
        ...rows,
        {},
        totalRow,
      ],
    };
  };

  applyReportWorksheetCurrencyFormats = (worksheet, headers) => {
    if (!worksheet || !worksheet['!ref']) return;

    const currencyColumnNames = new Set(
      Array.from(this.getDetailedReportCurrencyFields()).map((field) => this.formatExportColumnName(field))
    );
    const range = XLSX.utils.decode_range(worksheet['!ref']);

    headers.forEach((header, columnIndex) => {
      if (!currencyColumnNames.has(header)) return;

      for (let rowIndex = range.s.r + 1; rowIndex <= range.e.r; rowIndex += 1) {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: columnIndex });
        const cell = worksheet[cellAddress];

        if (cell && cell.t === 'n') {
          cell.z = '$#,##0.00';
        }
      }
    });
  };

  writeReportWorkbook = (exportData) => {
    const worksheet = XLSX.utils.json_to_sheet(exportData.rows, {
      header: exportData.headers,
    });
    const workbook = XLSX.utils.book_new();

    this.applyReportWorksheetCurrencyFormats(worksheet, exportData.headers);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');
    XLSX.writeFile(workbook, `WinLossReport_${this.getExportFileName()}.xlsx`);
  };

  navigateToPage = (page) => {
    this.props.navigate(page);    
  }



  handleExport = async() => {
    if (this.state.reportViewMode === 'days') {
      const exportData = this.buildDetailedReportExportRows({
        data: this.state.dailyReportData,
        firstColumnHeader: 'Date',
        firstColumnValue: (item) => this.formatGamingDay(item.shopName || item.date || item.dayData),
      });

      this.writeReportWorkbook(exportData);
      return;
    }
    if ( this.state.isExpandMode ) {
      const exportData = this.buildDetailedReportExportRows({
        data: this.state.selectedShopData,
        firstColumnHeader: 'Date',
        firstColumnValue: (item) => this.formatGamingDay(item.shopName || item.date || item.dayData),
      });

      this.writeReportWorkbook(exportData);
      return;
    }

    const exportData = this.buildDetailedReportExportRows({
      data: this.state.shopData,
      firstColumnHeader: 'Betting Shop',
      firstColumnValue: (item) => item.shopName || '--',
    });

    this.writeReportWorkbook(exportData);


    // const formatDate = (date, startOfDay = true) =>
    //   startOfDay
    //     ? new Date(date).toISOString().split('T')[0] + 'T00:00:00.000Z'
    //     : new Date(date).toISOString().split('T')[0] + 'T23:59:59.999Z';


    // // If dateRangeData already has them, use them
    // if (dateRangeData.startDate) {
    //   reportsParams.startDate = formatDate(dateRangeData.startDate, true);
    // }
    // if (dateRangeData.endDate) {
    //   reportsParams.endDate = formatDate(dateRangeData.endDate, false);
    // }
  };

  formatDateString = (dateStr) => {
    // Validate input format (MM_DD_YYYY)
    const regex = /^(\d{2})_(\d{2})_(\d{4})$/;
    const match = dateStr.match(regex);
    
    if (!match) {
      return "Invalid date format";
    }

    const [, day, month, year] = match;

    // Array of month abbreviations
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    // Convert month to number (1-based) and get abbreviation
    const monthNum = parseInt(month, 10);
    if (monthNum < 1 || monthNum > 12) {
      return "Invalid month";
    }
    const monthAbbr = months[monthNum-1];

    // Remove leading zero from day
    const dayNum = parseInt(day, 10);
    if (dayNum < 1 || dayNum > 31) {
      return "Invalid day";
    }

    // Validate year (basic check)
    const yearNum = parseInt(year, 10);
    if (yearNum < 1000 || yearNum > 9999) {
      return "Invalid year";
    }

    // Format the output
    return `${monthAbbr} ${dayNum}, ${year}`;
  };

  formatGamingDay = (dateValue) => {
    if (!dateValue) return '--';

    const dateString = String(dateValue);
    if (/^\d{2}_\d{2}_\d{4}$/.test(dateString)) {
      return this.formatDateString(dateString);
    }

    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
      return dateString;
    }

    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(date);
  };

  sortTableData = (columnName, data) => {
    const sortableFields = ['totalBetAmount', 'totalRedeemedPayout', 'totalPayoutAmount', 'netAmount', 'numberRedeemedTickets', 'numberSoldTickets'];
    
    if (!sortableFields.includes(columnName)) {
      console.warn(`Column ${columnName} is not sortable.`);
      return data;
    }

    const sortedData = [...data].sort((a, b) => {
      const valueA = parseFloat(a[columnName]) || 0;
      const valueB = parseFloat(b[columnName]) || 0;
      return valueB - valueA; // Descending order
    });

    return sortedData;
  };

  handleSort = (columnName) => {
    if (this.state.reportViewMode === 'days') {
      this.setState((prevState) => ({
        dailyReportData: this.sortTableData(columnName, prevState.dailyReportData)
      }));
    } else if (this.state.isExpandMode) {
      this.setState((prevState) => ({
        selectedShopData: this.sortTableData(columnName, prevState.selectedShopData)
      }));
    } else {
      this.setState((prevState) => ({
        shopData: this.sortTableData(columnName, prevState.shopData)
      }));
    }
  };


  render() {    
      const isDaysMode = this.state.reportViewMode === 'days';
      const showDaysLayout = this.state.isExpandMode || isDaysMode;

      return <>
      <div className="report reports-page-double-zero">
        <div className="report-top">
          <div className="report-top__left">
            <div className="spin-border dashbord-border">
              <div className="spin-light spin-light-top">
                <div className="spin-light-container">
                  {Array.from({ length: 15 }).map((_, index) => (
                    <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                  ))}
                </div>
              </div>
              <div className="spin-number">
                <div className="spin-number__text">
                  <span className="spin-number__text-big">WIN / LOSS REPORT</span> 
                </div> 
              </div>
              <div className="spin-light spin-light-bottom">
                <div className="spin-light-container">
                  {Array.from({ length: 15 }).map((_, index) => (
                    <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="validate_top-middel-rep">
          {!this.state.startDate ? ( 
              "No date selected"
            ) :  
            this.state.endDate === null ||
              moment(this.state.startDate).isSame(this.state.endDate, "day") ? (
              (() => {
                
                const date = moment(this.state.startDate);

              
                if (moment().isSame(date, "day")) {
                  return date.format("MMM DD, YYYY");
                }
               
                if (moment().subtract(1, "days").isSame(date, "day")) {
                  return date.format("MMM DD, YYYY");
                }
           
                return date.format("MMM DD, YYYY");
              })()
            ) : 
            (
              (() => {
                
                const start = moment(this.state.startDate);
                const end = moment(this.state.endDate);
                const rangeDays = end.diff(start, "days");  

              
                if (rangeDays === 1) {
                  return start.format("MMM DD, YYYY");
                }

                 
                if (moment().isSame(end, "day") && rangeDays > 1) {
                  return (
                    <>
                      {start.format("MMM DD, YYYY")}
                      {" - "}
                      {end.format("MMM DD, YYYY")}
                    </>
                  );
                }

                
                if (moment().isSame(end, "day") && rangeDays <= 2) {
                  return "Today";
                }

                 
                if (moment().subtract(1, "days").isSame(end, "day") && rangeDays <= 2) {
                  return "Yesterday";
                }

                if (this.state.activeDateSelected === 'LAST_7_DAYS' || this.state.activeDateSelected === 'LAST_30_DAYS') {
                  return (
                    <>
                      {start.format("MMM DD, YYYY")}
                      {" - "}
                      {end.subtract(1, "days").format("MMM DD, YYYY")}
                    </>
                  );
                }                             
                return (
                  <>
                    {start.format("MMM DD, YYYY")}
                    {" - "}
                    {end.format("MMM DD, YYYY")}
                  </>
                );
              })()
            )}



          </div>
          <div className="report-top__right">
            <button className="return-menu btn-yellow"  onClick={() => this.navigateToPage('/dashboard')}
            >RETURN TO MAIN MENU</button>
          </div>
        </div>
        <div className="report-middle">
        <div className="report_filter-date">
            <div className="report_filter-date-sl report_filter-date-mode">
              <select
                className="report-mode-select"
                name="reportViewMode"
                value={this.state.reportViewMode}
                onChange={this.handleReportViewModeChange}
              >
                <option value="shops">Shops</option>
                <option value="days">Days</option>
              </select>
            </div>
            <div
              className={'report_filter-date-item'}
              onClick={() => this.handleClickNormalMode()}
            >
              ALL SHOPS
            </div>
            <div
              className={`report_filter-date-item ${this.state.activeDateSelected==='TODAY' ? "date-active" : ""}`}
              onClick={() => this.handleDateRange("TODAY")}
            >
              TODAY
            </div>
            <div
              className={`report_filter-date-item ${this.state.activeDateSelected==='YESTERDAY' ? "date-active" : ""}`}
              onClick={() => this.handleDateRange("YESTERDAY")}
            >
              YESTERDAY
            </div>
            <div
              className={`report_filter-date-item ${this.state.activeDateSelected==='LAST_7_DAYS' ? "date-active" : ""}`}
              onClick={() => this.handleDateRange("LAST_7_DAYS")}
            >
              LAST 7 DAYS
            </div>
            <div
              className={`report_filter-date-item ${this.state.activeDateSelected==='LAST_30_DAYS' ? "date-active" : ""}`}
              onClick={() => this.handleDateRange("LAST_30_DAYS")}
            >
              LAST 30 DAYS
            </div>
            <div
              className={`report_filter-date-item-custom report_filter-date-item ${this.state.activeDateSelected==='CUSTOM' ? "date-active" : ""}`}
              onClick={() => this.handleDateRange("CUSTOM", true)}
            >
              <span className="report_filter-date-custom-span">CUSTOM</span>
              
            </div>
            <div
              className={'report_filter-date-item'}
              onClick={() => this.handleExport()}
            >
              EXPORT XLS
            </div>

            {this.state.isCalendarVisible && (
              <div className="calendar-container">
                <Datetime
                  onChange={this.handleDateChange}
                  open={true}
                  input={false}
                  timeFormat={false}
                  closeOnSelect={false}
                  ref={this.calendarRef}
                  isValidDate={(current) => {
 
                    if (!this.state.startDate || this.state.selectingEnd) return true;
   
                    return moment(current).isSameOrAfter(this.state.startDate, "day");
                  }}
                  renderDay={(props, currentDate, selectedDate) => {
                    let className = props.className;
                    if (this.state.startDate && this.state.endDate) {
                      if (currentDate.isBetween(this.state.startDate, this.state.endDate, "day", "[]")) {
                        className += " rdt-day-in-range";
                      }
                      if (currentDate.isSame(this.state.startDate, "day")) {
                        className += " rdt-day-start";
                      }
                      if (currentDate.isSame(this.state.endDate, "day")) {
                        className += " rdt-day-end";
                      }
                    } else if (this.state.startDate && !this.state.endDate) {
                      if (currentDate.isSame(this.state.startDate, "day")) {
                        className += " rdt-day-start";
                      }
                    }
                    return <td {...props} className={className}>{currentDate.date()}</td>;
                  }}

                
                  renderView={(mode, renderDefault, viewProps) => {
   
                    const defaultCalendar = renderDefault();
                    return (
                      <div>
                        {defaultCalendar}
             
                        <div style={{ textAlign: "center", marginTop: 8 }}>
                          <button
                            className="btn-ok"
                            onClick={() => {
                              this.setState({isCalendarVisible: false})                         
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    );
                  }}
                />
              </div>              )}
          </div>

          <div className="report-info">
            <div className="spin-report">
              <div className="spin-report-light spin-report-light-top">
                <div className="spin-report-light-container">
                  {Array.from({ length: 25 }).map((_, index) => (
                    <div className="spin-report-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                  ))}
                </div>
              </div>
                {this.state.isExpandMode
                  ? (
                    <div className="spin-report-info spin-number">
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.selWager)}</div>
                        <div className="spin-report-info-bottom one-color">WAGER</div>
                      </div>                
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.selRedeemedPayout)}</div>
                        <div className="spin-report-info-bottom two-color">PAYOUT RDM.</div>
                      </div>
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.selTotalPayout)}</div>
                        <div className="spin-report-info-bottom two-color">PAYOUT ELG.</div>
                      </div>
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.selRedeemedJackpotPayout)}</div>
                        <div className="spin-report-info-bottom two-color">JACKPOT RDM.</div>
                      </div>
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.selEligibleJackpotPayout)}</div>
                        <div className="spin-report-info-bottom two-color">JACKPOT ELG.</div>
                      </div>
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.selGross)}</div>
                        <div className="spin-report-info-bottom three-color">GROSS</div>
                      </div>
                    </div>
                  ) : (
                    <div className="spin-report-info spin-number">
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.wager)}</div>
                        <div className="spin-report-info-bottom one-color">WAGER</div>
                      </div>
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.redeemedPayout)}</div>
                        <div className="spin-report-info-bottom two-color">PAYOUT RDM.</div>
                      </div>
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.totalPayout)}</div>
                        <div className="spin-report-info-bottom two-color">PAYOUT ELG.</div>
                      </div>
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.redeemedJackpotPayout)}</div>
                        <div className="spin-report-info-bottom two-color">JACKPOT RDM.</div>
                      </div>
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.eligibleJackpotPayout)}</div>
                        <div className="spin-report-info-bottom two-color">JACKPOT ELG.</div>
                      </div>
                      <div className="spin-report-info__item">
                        <div className="spin-report-info-top">${this.formatCurrency(this.state.gross)}</div>
                        <div className="spin-report-info-bottom three-color">GROSS</div>
                      </div>
                    </div>
                  )}
              <div className="spin-report-light spin-report-light-bottom">
                <div className="spin-report-light-container">
                  {Array.from({ length: 25 }).map((_, index) => (
                    <div className="spin-report-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* <div>
            <button className='norm-mode-btn ' onClick={() => this.handleClickNormalMode()}>SHOW ALL SHOPS</button>
          </div> */}
          <div className="report-table">
            <div className="table-maket table-maket-no-marg">
              <table>
                <thead>
                  <tr>
                    <th>
                      <div className="table-header-with-filter">
                        {showDaysLayout ? 'GAMING DAY' : 'BETTING SHOP'}
                        {/* <img src={require('../../images/icons/filter-icon.svg')} alt="Filter" className="filter-icon" /> */}
                      </div>
                    </th>
                    <th onClick={() => this.handleSort('totalBetAmount')}>
                      <div className="table-header-with-filter">
                        WAGER
                        <img src={require('../../images/icons/filter-icon.svg')} alt="Filter" className="filter-icon" />
                      </div>
                    </th>
                    <th onClick={() => this.handleSort('totalRedeemedPayout')}>
                      <div className="table-header-with-filter">
                        PAYOUT RDM.
                        <img src={require('../../images/icons/filter-icon.svg')} alt="Filter" className="filter-icon" />
                      </div>
                    </th>
                    <th onClick={() => this.handleSort('totalPayoutAmount')}>
                      <div className="table-header-with-filter">
                        PAYOUT ELG.
                        <img src={require('../../images/icons/filter-icon.svg')} alt="Filter" className="filter-icon" />
                      </div>
                    </th>
                    <th>
                      <div className="table-header-with-filter">
                        JACKPOT RDM.
                      </div>
                    </th>
                    <th>
                      <div className="table-header-with-filter">
                        JACKPOT ELG.
                      </div>
                    </th>
                    <th onClick={() => this.handleSort('netAmount')}>
                      <div className="table-header-with-filter">
                        GROSS
                        <img src={require('../../images/icons/filter-icon.svg')} alt="Filter" className="filter-icon" />
                      </div>
                    </th>
                    {showDaysLayout && (
                      <>
                        <th onClick={() => this.handleSort('numberSoldTickets')}>
                          <div className="table-header-with-filter">
                            TICKETS SOLD
                            <img src={require('../../images/icons/filter-icon.svg')} alt="Filter" className="filter-icon" />
                          </div>
                        </th>
                        <th onClick={() => this.handleSort('numberRedeemedTickets')}>
                          <div className="table-header-with-filter">
                            TICKETS REDEEMED
                            <img src={require('../../images/icons/filter-icon.svg')} alt="Filter" className="filter-icon" />
                          </div>
                        </th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody> 
                {
                  isDaysMode
                    ? (
                        this.state.dailyReportData.length > 0
                          ? this.state.dailyReportData.map((item) => (
                              <tr key={item._id || item.shopName}>
                                <td className="table-maket-col_yellow">{this.formatGamingDay(item.shopName)}</td>
                                <td>${this.formatCurrency(item.totalBetAmount)}</td>
                                <td>${this.formatCurrency(item.totalRedeemedPayout)}</td>
                                <td>${this.formatCurrency(item.totalPayoutAmount)}</td>
                                <td>${this.formatCurrency(item.totalRedeemedJackpotPayout)}</td>
                                <td>${this.formatCurrency(item.totalEligibleJackpotPayout)}</td>
                                <td>${this.formatCurrency(item.netAmount)}</td>
                                <td>{item.numberSoldTickets || 0}</td>
                                <td>{item.numberRedeemedTickets || 0}</td>
                              </tr>
                            ))
                          : <tr><td colSpan="9">No data available</td></tr>
                      )
                    : this.state.isExpandMode
                    ? (
                        this.state.selectedShopData.length > 0
                          ? this.state.selectedShopData.map((item) => (
                              <tr key={item.shopName} onClick={() => this.handleClickNormalMode()}>
                                <td className="table-maket-col_yellow clickable-row">{this.formatGamingDay(item.shopName)}</td>
                                <td>${this.formatCurrency(item.totalBetAmount)}</td>
                                <td>${this.formatCurrency(item.totalRedeemedPayout)}</td>
                                <td>${this.formatCurrency(item.totalPayoutAmount)}</td>
                                <td>${this.formatCurrency(item.totalRedeemedJackpotPayout)}</td>
                                <td>${this.formatCurrency(item.totalEligibleJackpotPayout)}</td>
                                <td>${this.formatCurrency(item.netAmount)}</td>
                                <td>{item.numberSoldTickets || 0}</td>
                                <td>{item.numberRedeemedTickets || 0}</td>
                              </tr>
                            ))
                          : <tr><td colSpan="9">No data available</td></tr>
                      )
                    : (
                        this.state.shopData.length > 0
                          ? this.state.shopData.map((item) => (
                              <tr key={item.bettingShopId} onClick={() => this.handleClickShop(item.bettingShopId, item)}>
                                <td className="table-maket-col_yellow clickable-row">{item.shopName}</td>
                                <td>${this.formatCurrency(item.totalBetAmount)}</td>
                                <td>${this.formatCurrency(item.totalRedeemedPayout)}</td>
                                <td>${this.formatCurrency(item.totalPayoutAmount)}</td>
                                <td>${this.formatCurrency(item.totalRedeemedJackpotPayout)}</td>
                                <td>${this.formatCurrency(item.totalEligibleJackpotPayout)}</td>
                                <td>${this.formatCurrency(item.netAmount)}</td>
                              </tr>
                            ))
                          : <tr><td colSpan="7">No shops available</td></tr>
                      )
                }

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </>;
  }
}

export default withNavigation(ReportsPage);



  //STILL NEED TO CREATE FUNCTIONALITY FOR 

  //Basket, or a five number bet, and allows players to bet on the zero, double zero, 1, 2, and 3. Payout – 6:1.
